import React from "react";
import { Row, Col } from "react-bootstrap";
import { DatePicker, Button, InputBox } from "../../Common";
import DropDown from "../../Common/DropDown";
import styles from "./accountTransaction.module.css";

const Filter = ({
  accountNo,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  onSearch,
  loading = false,
  errorMessage,
  finTranTypeID = {
    ACATS_CASH: "ACATS CASH",
    COMM: "Commission",
    CSD: "Withdrawal",
    CSR: "Deposit",
    DEL: "DEL",
    DIV: "Dividend",
    DIVM: "DIVM",
    DIVTAX: "Dividend Tax",
    FEE: "Fees",
    INT: "Interest",
    JNLC: "JNLC",
    MERGER_ACQUISITION: "Merger Acquisition",
    PTP_WITHHOLDING: "PTP Withholding",
    REC: "REC",
    SLIP: "SLIP",
    SLIPNRA: "SLIPNRA",
    SPINOFF: "SPINOFF",
    SPUR: "Buy",
    SSAL: "Sell",
    STCK: "STCK",
    STOCK_SPLIT: "Stock Split",
    XTRF: "XTRF",
  },
  userId,
  setUserId,
  selectedTransactionType,
  setSelectedTransactionType,
  filterUserId = true,
}) => {
  const transactionTypeOptions = [
    { label: "ALL", value: "ALL" },
    ...Object.keys(finTranTypeID).map((key) => ({
      label: finTranTypeID[key],
      value: key,
    })),
  ];

  const handleTransactionTypeChange = (selectedKey) => {
    if (!selectedKey) {
      setSelectedTransactionType({ key: "", value: "" });
      return;
    }
    if (selectedKey === "ALL") {
      setSelectedTransactionType({ key: "ALL", value: "" });
      return;
    }
    setSelectedTransactionType({
      key: selectedKey,
      value: finTranTypeID[selectedKey],
    });
  };

  return (
    <>
    <Row>
      <Col md={2}>
        <label className={styles.label}>Start Date</label>
        <div className={styles.datestyle}>
          <DatePicker
            placeholderText="Start Date"
            dateFormat="yyyy-MM-dd"
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            minDate={new Date("2016-01-01")}
            maxDate={new Date()}
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
          />
        </div>
       
      </Col>
      <Col md={2}>
        <label className={styles.label}>End Date</label>
        <div className={styles.datestyle}>
          <DatePicker
            placeholderText="End Date"
            dateFormat="yyyy-MM-dd"
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            minDate={startDate}
            maxDate={new Date()}
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
          />
        </div>
      </Col>
      {filterUserId === true && (
        <Col md={2}>
          <label className={styles.label}>Cust Id </label>
          <InputBox
            placeholder="Cust Id"
            type="text"
            onChange={(e) => setUserId(e.target.value)}
            name="CustId"
            value={userId}
          />
        </Col>
      )}

      <Col md={2}>
        <DropDown
          label="Transaction Type"
          value={selectedTransactionType?.key || ""}
          data={transactionTypeOptions}
          onChange={handleTransactionTypeChange}
          placeholder="Select Type"
          height="40px"
          labelKey="label"
          valueKey="value"
          className={styles.transactionTypeDropdown}
        />
      </Col>
      <Col md={2}>
        <div style={{ marginTop: "23px" }}>
          <Button
            title="Search"
            loading={loading}
            onClick={onSearch}
            disabled={accountNo === "" && startDate === "" && endDate === ""}
          />
        </div>
      </Col>
    </Row>
      {errorMessage && (
      <Row>
        <Col md={12}>
          <div className={styles.errorMessage}>{errorMessage}</div>
        </Col>
      </Row>
    )}
    </>
  );
};

export default Filter;
